import React from 'react';
import PropTypes from 'prop-types';

const Label = (props) => {
  const { children, color, labelSize } = props;
  return (
    <div className={`label ${color} ${labelSize}`}>
      {children}
    </div>
  );
};

Label.defaultProps = {
  color: 'blue', // red
  labelSize: '', // min
};

Label.propTypes = {
  color: PropTypes.string,
  labelSize: PropTypes.string,
  children: PropTypes.node,
};

export default Label;
